import React from 'react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, tomos } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="solucion" className="bg-night" data-id="element-148" data-mp="3gihoxkzfi0s2">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-149" data-mp="3bidfug0uo8bv">
        <Reveal className="text-center" data-id="element-150" data-mp="3bkpuaj7eg0k6">
          <h2 id="solucion" className="mx-auto max-w-3xl font-display text-xl uppercase leading-[1.08] text-white sm:text-3xl lg:text-4xl" data-id="element-151" data-mp="36iqsvev7zdpv">
            La solución que estabas buscando —{' '}
            <span className="text-volt" data-id="element-152" data-mp="2wspg3j8bhhq9">un sistema 6 en 1</span>
          </h2>
          <p className="mt-1 text-[0.85rem] font-bold text-white sm:text-base" data-id="element-153" data-mp="2stgjm6lw75r0">
            6 tomos en un solo sistema, creados para aprender desde cero.
          </p>
          <p className="mt-2 font-display text-base uppercase text-volt sm:text-xl" data-id="element-154" data-mp="2ity1zwtgfw24">
            ⚡ {PRODUCT}
          </p>
          <p className="mx-auto mt-2 max-w-2xl text-[0.82rem] leading-snug text-steel sm:text-sm" data-id="element-155" data-mp="2dw614dau0zls">
            No es simplemente otro ebook de electricidad. Es una ruta de
            aprendizaje que organiza los conocimientos fundamentales para que
            comprendas qué aprender primero, qué viene después y cómo se conecta
            cada concepto.
          </p>
        </Reveal>

        <ol className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-156" data-mp="yzbupdjih1by">
          {tomos.map((tomo, i) => <Reveal key={tomo.label} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-white/10 border-t-4 border-t-volt bg-carbon p-4" data-id="element-157" data-mp="1mqr05f6l3yrf" data-mpi={i}>
              <span className="self-start rounded bg-volt px-2 py-0.5 font-display text-[0.68rem] uppercase tracking-wide text-carbon sm:text-xs" data-id="element-158" data-mp="1ctmctc105x91">
                {tomo.label}
              </span>
              <h3 className="mt-2 font-display text-[0.95rem] uppercase leading-tight text-white sm:text-base" data-id="element-159" data-mp="1eh7s1defmm9">
                {tomo.title}
              </h3>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-160" data-mp="28x369cvla22r">
                {tomo.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}